import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import CartItem from "../components/CartItem";

export default function Cart(){
    const { items, totalPrice, clearCart } = useCart();
    if(items.length === 0){
        return <div
            className="container"
        >
            <h3>Your cart is empty.</h3>
            <Link
                to="/"
                className="btn btn-primary mt-3"
            >Go Shopping</Link>

        </div>;
    }

    return <div
        className="container"
    >
        <h2
            className="mb-4"
        >Shopping Cart</h2>
        <table>
            <thead>
                <th>Product</th>
                <th>Price</th>
                <th
                    className="text-center"
                >Qty</th>
                <th>
                    Total
                </th>
                <th></th>
            </thead>
            <tbody>
                {items.map(i=><CartItem
                    key={i.id}
                    item={i}
                ></CartItem>)}
            </tbody>
        </table>
        <div
            className="d-flex justify-content-between align-items-center my-4"
        >
            <h4>Total: ${totalPrice.toFixed(2)}</h4>
            <div>
                <button
                    className="btn btn-outline-danger me-2"
                    onClick={clearCart}
                >Clear Cart</button>
                <Link
                    to="../checkout"
                    className="btn btn-success"
                >Proceed to Checkout</Link>
            </div>
        </div>
    </div>
}